import { Evnt_dispatch } from '../Evnt/Evnt.dispatch'

export function E2E_dispatchSyncSuccess() {
    Evnt_dispatch('E2E_SyncSuccess')
}

export function E2E_dispatchNonWorkflowActionsSynced() {
    Evnt_dispatch('E2E_NonWorkflowActionsSynced')
}

export function E2E_dispatchOpenReportSaved() {
    Evnt_dispatch('E2E_OpenReportSaved')
}

export function E2E_notificationsSynced() {
    Evnt_dispatch('E2E_NotificationsSynced')
}

export function E2E_reportStatusChanged() {
    Evnt_dispatch('E2E_ReportStatusChanged')
}

export function E2E_deviceSyncComplete() {
    Evnt_dispatch('E2E_DeviceSyncComplete')
}

export function E2E_syncOngoingReportsStarted() {
    Evnt_dispatch('E2E_SyncOngoingReportsStarted')
}

export function E2E_uploadsProcessed() {
    Evnt_dispatch('E2E_UploadsProcessed')
}

export function E2E_dispatchReportInvalid() {
    Evnt_dispatch('E2E_ReportInvalid')
}
